import React from 'react';

var darkBlue = '#133A53';

export default class PositionToggle extends React.Component {
	handleLeftClicked() {
		if(this.props.position == 'left') {
			this.props.updatePosition('right');
		} else {
			this.props.updatePosition('left');
		}
	}
	handleRightClicked() {
		if(this.props.position == 'right') {
			this.props.updatePosition('left');
		} else {
			this.props.updatePosition('right');
		}
	}
	render() {
		var { position } = this.props;

		var linkHeight = 20;

		var linkStyle = {
			opacity: 0,
			background: darkBlue,
			height: linkHeight,
			width: linkHeight,
			borderRadius: linkHeight,
			fontSize: 13,
			fontWeight: 400,
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			cursor: 'pointer',
			color: '#fff',
			userSelect: 'none'
		};

		var activeStyle = {
			opacity: 1
		};

		var leftStyle = position == 'left' ? {...linkStyle, ...activeStyle} : linkStyle;
		var rightStyle = position == 'right' ? {...linkStyle, ...activeStyle} : linkStyle;

		var wrapperStyle = {
			background: '#fff', 
			paddingLeft: 3, 
			paddingRight: 3, 
			display: 'flex', 
			alignItems: 'center',
			borderRadius: 30, 
			height: 25, 
		};

		return (
			<div style={wrapperStyle}>
				<span style={leftStyle} onClick={this.handleLeftClicked.bind(this)} href="#">L</span>
				<span style={rightStyle}  onClick={this.handleRightClicked.bind(this)} href="#">R</span>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/PositionToggle.js